import EmblaCarousel from "@crescentParts/Components/EmblaCarousel";
import TrainingFiltersAccordionSection, {
    FacetModel,
} from "@crescentParts/Components/Training/TrainingFiltersAccordionSection";
import TrainingRedirectionPopup from "@crescentParts/Components/Training/TrainingRedirectionPopup";
import TrainingRegistrationPopup from "@crescentParts/Components/Training/TrainingRegistrationPopup";
import setFilters from "@crescentParts/Handlers/Custom/CrescentPartsTrainingHandler";
import calendarIcon from "@crescentParts/Icons/Training/Calendar";
import locationIcon from "@crescentParts/Icons/Training/Location";
import peuIcon from "@crescentParts/Icons/Training/Peu";
import restrictionIcon from "@crescentParts/Icons/Training/Restriction";
import tagIcon from "@crescentParts/Icons/Training/Tag";
import { CustomCrescentPartsTrainingState } from "@crescentParts/Store/CrescentPartsTraining/TrainingsReducer";
import trainingEnquiry from "@crescentParts/Store/Data/TrainingEnquiry/Handler/TrainingEnquiryHandler";
import getTrainingProduct from "@crescentParts/Store/Data/TrainingProducts/Handler/TrainingProductHandler";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { HasShellContext, useShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import siteMessage from "@insite/client-framework/SiteMessage";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import FlexItem from "@insite/content-library/Widgets/Brand/FlexItem";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, useHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import isEmpty from "lodash/isEmpty";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

const mapDispatchToProps = {
    setFilters,
    trainingEnquiry,
    getTrainingProduct,
    loadRealTimeInventory
};

const mapStateToProps = (state: CustomCrescentPartsTrainingState) => {
    const {
        typeFilters,
        locationFilters,
        priceFilters,
        peuFilters,
        restrictionFilters,
        appliedFilters,
        selectedFilterNamesArr,
        filteredTrainings,
    } = state.customCrescentPartsTraining;
    const createAccountPageLink = getPageLinkByPageType(state, "CreateAccountPage");
    return {
        location: getLocation(state),
        typeFilters,
        locationFilters,
        priceFilters,
        peuFilters,
        restrictionFilters,
        appliedFilters,
        selectedFilterNamesArr,
        filteredTrainings,
        session: getSession(state),
        createAccountUrl: createAccountPageLink ? `${createAccountPageLink.url}` : undefined,
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        TrainingEnquiry: state.cpeState.TrainingEnquiry,
        cartPageUrl: getPageLinkByPageType(state, "CartPage")?.url,
    };
};
export interface NewsListViewStyles {
    container?: InjectableCss;
    card?: InjectableCss;
    trainingType?: TypographyPresentationProps;
    title?: TypographyPresentationProps;
    detailsWrapper?: InjectableCss;
    detailIcon?: IconPresentationProps;
    location?: TypographyPresentationProps;
    date?: TypographyPresentationProps;
    endDate?: TypographyPresentationProps;
    price?: TypographyPresentationProps;
    buttonWrapper?: InjectableCss;
    button?: ButtonPresentationProps;
    cardsContainer?: InjectableCss;
    trainingCardImg?: InjectableCss;
    trainingCardContent?: InjectableCss;
    featuredContainer?: InjectableCss;
    featuredTitleSection?: InjectableCss;
    featuredCardContent?: InjectableCss;
    featuredCardsContainer?: InjectableCss;
    featuredCardImg?: InjectableCss;
    featuredItem?: InjectableCss;
    featuredButtonWrapper?: InjectableCss;
    featuredRegisterNowButton?: ButtonPresentationProps;
    featuredKnowMoreLink?: LinkPresentationProps;
    learnMoreLink?: LinkPresentationProps;
    trainingsGridContainer?: GridContainerProps;
    trainingTitleSection?: GridItemProps;
    filtersGridItem?: GridItemProps;
    cardsGridItem?: GridItemProps;
    filterHeadingWrapper?: InjectableCss;
    filterSectionHeading?: TypographyPresentationProps;
    registerNowButton?: ButtonPresentationProps;
    filterSectionsWrapper?: InjectableCss;
    featuredTrainingDate?: TypographyPresentationProps;
    noResult?: TypographyPresentationProps;
    noResultGridItem?: GridItemProps;
    datesWrapper?: InjectableCss;
    trainingRedirectionModal?: ModalPresentationProps;
    trainingNotificationWrapper?: InjectableCss;
    trainingNotificationOverlay?: InjectableCss;
    trainingNotificationContentWrapper?: InjectableCss;
    heading?: TypographyPresentationProps;
    trainingNotificationButton?: ButtonPresentationProps;
    buttonsWrapper?: InjectableCss;
    cancelButton?: ButtonPresentationProps;
    sendButton?: ButtonPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    btnSpinner?: LoadingSpinnerProps;
    containerEnquiry?: InjectableCss;
    messageGridItem?: GridItemProps;
    messageTextArea?: TextAreaProps;
    modal?: ModalPresentationProps;
    qty?: TypographyPresentationProps;
    textInput?: TextFieldPresentationProps;
    errorText?: TypographyPresentationProps;
}

export const newsListViewStyles: NewsListViewStyles = {
    container: {
        css: css`
            margin-top: -40px;
        `,
    },
    trainingTitleSection: {
        width: 12,
        css: css`
            padding: 0 0 20px 0;
        `,
    },
    cardsGridItem: {
        width: [12, 12, 8, 8, 9],
        css: css`
            display: grid;
            height: fit-content;
            grid-template-columns: repeat(3, 1fr);
            row-gap: 20px;
            column-gap: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            grid-template-columns: repeat(1, 1fr);
                            padding-left: 0;
                            padding-right: 0;
                        `,
                        null,
                        css`
                            grid-template-columns: repeat(2, 1fr);
                            padding-top: 0;
                            padding-right: 0;
                            padding-left: 10.5px;
                        `,
                        css`
                            grid-template-columns: repeat(2, 1fr);
                        `,
                        css`
                            grid-template-columns: repeat(3, 1fr);
                        `,
                    ],
                    "min",
                )}
        `,
    },
    trainingCardImg: {
        css: css`
            max-height: 160px;
            height: 160px;
            width: 100%;
            img {
                height: 100%;
                object-fit: contain;
            }
        `,
    },
    card: {
        css: css`
            border-radius: 8px;
            height: 100%;
            background: ${getColor("secondary")};
            overflow: hidden;
            display: flex;
            flex-direction: column;
        `,
    },
    trainingType: {
        variant: "headerTertiary",
        color: "#636363",
        css: css`
            text-transform: capitalize;
            margin-bottom: 5px;
        `,
    },
    title: {
        variant: "h5",
        color: "text.accent",
        css: css`
            flex-grow: 1;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-bottom: 0;
                        `,
                        null,
                        css`
                            margin-bottom: 12px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    detailsWrapper: {
        css: css`
            margin-bottom: 8px;
            display: flex;
            align-items: start;
        `,
    },
    detailIcon: {
        size: 16,
        css: css`
            margin-right: 14px;
            margin-top: 3px;
        `,
    },
    location: {
        variant: "p",
        color: "text.accent",
        css: css`
            margin-bottom: 0;
        `,
    },
    datesWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    date: {
        variant: "p",
        color: "text.accent",
        css: css`
            margin-bottom: 0;
        `,
    },
    endDate: {
        variant: "p",
        color: "text.accent",
        css: css`
            margin-top: 8px;
            margin-bottom: 0;
        `,
    },
    price: {
        variant: "p",
        color: "text.accent",
        css: css`
            margin-bottom: 0;
        `,
    },
    trainingCardContent: {
        css: css`
            flex-grow: 1;
            padding: 8px 20px 15px 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        `,
    },
    featuredTitleSection: {
        css: css`
            margin-bottom: 26px !important;
        `,
    },
    featuredContainer: {
        css: css`
            background: ${getColor("secondary")};
            padding-top: 53px;
            padding-bottom: 60px;
            > .embla__container {
                position: relative;
                > div {
                    &:nth-of-type(2) {
                        > div {
                            > div {
                                > div {
                                    column-gap: 20px;
                                }
                            }
                        }
                    }
                    &:nth-of-type(1) {
                        position: absolute;
                        left: -22px;
                        z-index: 1;
                        margin-bottom: auto;
                        margin-top: auto;
                        > button {
                            border: none !important;
                        }
                    }
                    &:nth-of-type(3) {
                        position: absolute;
                        right: -22px;
                        z-index: 1;
                        margin-bottom: auto;
                        margin-top: auto;
                        > button {
                            border: none !important;
                        }
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-left: 2rem;
                            padding-right: 2rem;
                        `,
                        null,
                        null,
                        css`
                            max-width: 100%;
                            padding-left: 80px;
                            padding-right: 80px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    featuredCardsContainer: {
        css: css`
            display: grid;
            gap: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            grid-template-columns: repeat(1, 1fr);
                        `,
                        null,
                        css`
                            grid-template-columns: repeat(2, 1fr);
                        `,
                        css`
                            grid-template-columns: repeat(3, 1fr);
                        `,
                    ],
                    "min",
                )};
        `,
    },
    featuredTrainingDate: {
        color: "primary",
    },
    featuredItem: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    featuredButtonWrapper: {
        css: css`
            display: grid;
            gap: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            grid-template-columns: repeat(1, 1fr);
                        `,
                        null,
                        null,
                        css`
                            grid-template-columns: repeat(2, 1fr);
                        `,
                    ],
                    "min",
                )}
        `,
    },
    featuredRegisterNowButton: {
        css: css`
            flex: 1;
            width: 100%;
            font-size: 16px;
        `,
    },
    featuredKnowMoreLink: {
        typographyProps: {
            weight: 600,
        },
        css: css`
            flex: 1;
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            justify-content: center;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    featuredCardImg: {
        css: css`
            max-height: 180px;
            height: 180px;
            width: 100%;
            img {
                height: 100%;
                object-fit: contain;
                border-radius: 8px;
            }
        `,
    },
    featuredCardContent: {
        css: css`
            flex-grow: 1;
            padding: 12px 0 0 0;
            display: flex;
            flex-direction: column;
        `,
    },
    learnMoreLink: {
        typographyProps: {
            weight: 600,
        },
    },
    trainingsGridContainer: {
        gap: 21,
        css: css`
            max-width: 100% !important;
            margin-top: 40px;
        `,
        offsetCss: css`
            width: 100% !important;
            margin: 0;
            margin-bottom: 40px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0 1rem;
                        `,
                        null,
                        null,
                        css`
                            max-width: 100%;
                            padding: 0 80px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 10px;
            align-items: center;
        `,
    },
    registerNowButton: {
        css: css`
            width: 100%;
        `,
    },
    // Filter Section
    filtersGridItem: {
        width: [12, 12, 4, 4, 3],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-left: 0;
                            padding-right: 0;
                        `,
                        null,
                        css`
                            padding-top: 0;
                            padding-left: 0;
                            padding-right: 10.5px;
                        `,
                    ],
                    "min",
                )}
            [class^="AccordionSectionPanel"] {
                padding: 0px 20px 15px 20px;
            }
        `,
    },
    filterHeadingWrapper: {
        css: css`
            background: ${getColor("secondary")};
            border-radius: 6px;
            padding: 12px 20px;
            width: 100%;
            margin-bottom: 10px;
        `,
    },
    filterSectionHeading: {
        variant: "h6",
        color: "text.accent",
        css: css`
            margin-bottom: 0;
        `,
    },
    filterSectionsWrapper: {
        css: css`
            width: 100%;
        `,
    },
    // Filter Section Ends

    noResultGridItem: {
        width: [12, 12, 8, 8, 9],
        css: css`
            justify-content: center;
        `,
    },
    trainingRedirectionModal: {
        sizeVariant: "small",
    },
    trainingNotificationWrapper: {
        css: css`
            width: 100%;
            display: flex;
            align-items: stretch;
            background: #F6F4F6;
            margin: 49px 0px;
            padding: 50px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin: 49px 0px;
                        `,
                        null,
                        null,
                        css`
                            margin: 49px 0px;
                        `,
                    ],
                    "min",
                );
            }}
        `
    },
    trainingNotificationOverlay: {
        css: css`
            width: 100%;
            text-align: center;
        `
    },
    trainingNotificationContentWrapper: {
        css: css`
            display: flex;
            gap: 20px;
            align-items: center;
            justify-content: space-between;
        `
    },
    heading: {
        variant: "h2",
        css: css`
            font-size: 30px !important;
            font-weight: 700;
            color: ${getColor("text.accent")};
            text-align: left;
            line-height: 38px;
            margin-bottom: 1rem;
            display: block;
        `,
    },
    trainingNotificationButton: {
        css: css`
            flex-shrink: 0;
        `,
    },
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    btnSpinner: {
        css: css`
            margin: auto;
            width: 20px;
            height: 16px;
        `,
    },
    containerEnquiry: {
        css: css`
        `,
    },
    messageGridItem: {
        width: 12,
        css: css`
        display: flex;
        flex-direction: column;
        `
    },
    modal: {
        size: 600,
    },
    buttonsWrapper: {
        css: css`
            margin-top: 30px;
            text-align: right;
        `,
    },
    cancelButton: {
        variant: "secondary",
    },
    sendButton: {
        css: css`
            margin-left: 10px;
        `,
    },
    qty: {
        variant: "p",
        color: "text.accent",
        css: css`
            margin-bottom: 0;
            color: #79242F;
            font-weight: 700;
        `,
    },
};

const styles = newsListViewStyles;

interface OwnProps {
    trainings: any[];
    id: string;
    links: SafeDictionary<PageLinkModel>;
    numberOfRanges: number; 
}

type Props = OwnProps &
    ThemeProps<BaseTheme> &
    HasShellContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> & HasToasterContext & HasHistory;

const getDateWithMonthName = (dateObj: Date) => {
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    return `${dateObj.getDate()} ${months[dateObj.getMonth()]} ${dateObj.getFullYear()}`;
};

const getTime = (trainingDate: string) => {
    const time = formatAMPM(new Date(trainingDate));
    return time;
};

const formatAMPM = (date: Date) => {
    let hours = date.getHours();
    let minutes: string | number = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours || 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    const time = `${hours}:${minutes} ${ampm}`;
    return time;
};

const crescentPartsTrainingsListView: React.FC<Props> = ({
    trainings: receivedTrainings,
    id,
    theme,
    links,
    location,
    setFilters,
    typeFilters,
    locationFilters,
    priceFilters,
    peuFilters,
    restrictionFilters,
    selectedFilterNamesArr,
    filteredTrainings,
    session,
    createAccountUrl,
    signInUrl,
    TrainingEnquiry,
    trainingEnquiry,
    toaster,
    getTrainingProduct,
    loadRealTimeInventory,
    cartPageUrl,
    numberOfRanges
}) => {
    const [maxCarouselColumns, setMaxCarouselColumns] = React.useState<number>();
    const [windowResizeTime, setWindowResizeTime] = React.useState(0);
    const [registrationModalOpen, setRegistrationModalOpen] = React.useState<boolean>(false);
    const [trainingRedirectModalOpen, setTrainingRedirectModalOpen] = React.useState<boolean>(false);
    const [selectedTraining, setSelectedTraining] = React.useState<string>("");
    const [selectedAddress, setSelectedAddress] = React.useState<string>("");
    const [selectedStartDate, setSelectedStartDate] = React.useState<string>("");
    const [selectedEndDate, setSelectedEndDate] = React.useState<string>("");
    const history = useHistory();
    const [initialLoad, setInintialLoad] = React.useState<boolean>(true);
    const [isTrainingCheckModel, setIsTrainingCheckModel] = React.useState<boolean>(false);
    const [message, setMessage] = React.useState<string>("");
    const [formEmail, setFormEmail] = React.useState<string>("");
    const [emailError, setEmailError] = React.useState<string>("");
    const [formName, setFormName] = React.useState<string>("");
    const [nameError, setNameError] = React.useState<string>("");
    const [trainingProductWithId, setTrainingProductWithId] = React.useState<any>([]);
    const queryParams: any = parseQueryString(location.search);
    const [isInventoryLoading, setIsInventoryLoading] = React.useState<boolean>(false);
    const [isCheckInventory, setIsCheckInventory] = React.useState<boolean>(false);
    const [selectTrainingQty, setSelectTrainingQty] = React.useState(null);
    const {isInShell} = useShellContext();
    const trainings = receivedTrainings.sort(
        (
            a: { fields: { trainingDate: string | number | Date } },
            b: { fields: { trainingDate: string | number | Date } },
        ): any => {
            // Sort trainings by date older -> newer
            const secondDate: any = new Date(b?.fields?.trainingDate);
            const firstDate: any = new Date(a?.fields?.trainingDate);
            return firstDate - secondDate;
        },
    );

    React.useEffect(() => {
        setFilters({
            trainings,
            queryParams,
            initialLoad,
            numberOfRanges
        });
        window.addEventListener("resize", onWindowResize);
        onWindowResize();
        setInintialLoad(false);
        if(session.isAuthenticated) {
            const trainingProduct = trainings.map((product: any) => product.name);
            setIsInventoryLoading(true);
            fetchInventory(trainingProduct);
        }
        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);

    React.useEffect(() => {
        if (!initialLoad) {
            setFilters({
                trainings,
                queryParams,
                initialLoad,
                numberOfRanges
            });
        }
    }, [location.search]);

    React.useEffect(() => {
        const newMaxCarouselColumns = getMaxCarouselColumns();
        setMaxCarouselColumns(newMaxCarouselColumns);
    }, [maxCarouselColumns, windowResizeTime]);

    const onWindowResize = () => {
        setWindowResizeTime(Date.now());
    };

    const getMaxCarouselColumns = React.useCallback(() => {
        const maxNumberOfColumns = maxCarouselColumns || 3;
        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let noOfCarouselColumns: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            noOfCarouselColumns = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            noOfCarouselColumns = 2;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            noOfCarouselColumns = 2;
        } else {
            noOfCarouselColumns = 3;
        }
        return noOfCarouselColumns;
    }, [maxCarouselColumns]);

    const updateQuery = (facet: FacetModel) => {
        const updatedFilterTypeQueryParamsArr = queryParams[facet.filterType]?.split("_") || [];
        const ind = updatedFilterTypeQueryParamsArr.findIndex(
            (item: string) => item.toLowerCase() === facet.name.toLowerCase(),
        );

        if (ind === -1) {
            updatedFilterTypeQueryParamsArr.push(facet.name.toLowerCase());
        } else {
            updatedFilterTypeQueryParamsArr.splice(ind, 1);
        }

        let updatedQueryParams = { ...queryParams };
        if (updatedFilterTypeQueryParamsArr.length === 0) {
            delete updatedQueryParams[facet.filterType];
        } else {
            updatedQueryParams = {
                ...queryParams,
                [facet.filterType]: updatedFilterTypeQueryParamsArr.join("_"),
            };
        }

        const query = isEmpty(updatedQueryParams) ? "" : `?${new URLSearchParams(updatedQueryParams).toString()}`;
        history.push(`/Training/CrescentPartsTraining${query}`);
    };

    const handleFacetChange = (facet: FacetModel) => {
        updateQuery(facet);
    };
    
    const openModalHandler = (
        registrationType: string,
        externalUrl: any,
        trainingTitle: string,
        trainingAddress: string,
        trainingStartDate: string,
        trainingEndDate: string,
        qtyOnHand: any,
        checkInventory?:boolean,
    ) => {
        if(!isInventoryLoading) {
            if(session.isAuthenticated) {
                if(registrationType === "regExternal" && externalUrl){
                    if (externalUrl.startsWith("http")) {
                        if (isInShell) {
                            return;
                        }
             
                        window.location.href = externalUrl;
                    } else {
                        history.push(externalUrl);
                    }
                } else{
                setRegistrationModalOpen(true);
                setSelectedTraining(trainingTitle);
                setSelectedAddress(trainingAddress);
                setSelectedStartDate(trainingStartDate);
                setSelectedEndDate(trainingEndDate);
                setSelectTrainingQty(qtyOnHand);
                setIsCheckInventory(!!checkInventory )
            }
            } else {
                setTrainingRedirectModalOpen(true);
            }
        }
    };
    
    const featuredCardContent = (training: any, product: any) => {
        return (
            <>
                <Clickable
                    href={links[training.nodeId]?.url}
                    target={training?.fields?.openInNewWindow ? "_blank" : ""}
                    css={css`
                        background: #fff;
                    `}
                >
                    <LazyImage {...styles.featuredCardImg} src={training?.fields?.trainingImage}></LazyImage>
                </Clickable>

                <StyledWrapper {...styles.featuredCardContent}>
                    {training?.fields?.trainingDate && (
                        <Typography {...styles.featuredTrainingDate}>
                            {getDateWithMonthName(new Date(training?.fields?.trainingDate))}
                        </Typography>
                    )}

                    <Link
                            href={links[training.nodeId]?.url}
                            target={training?.fields?.openInNewWindow ? "_blank" : ""}
                            {...styles.featuredKnowMoreLink}
                        >
                            <Typography {...styles.title}>{training?.fields?.title}</Typography>
                    </Link>
                    <StyledWrapper {...styles.featuredButtonWrapper}>
                        {training?.fields?.registrationType !== "regNotRequired" &&
                        <>
                        {
                           product?.byPassInventory ? <Button
                           variant="secondary"
                           {...styles.featuredRegisterNowButton}
                           onClick={() =>
                               openModalHandler(
                                   training?.fields?.registrationType || "", 
                                   training?.fields?.externalLink?.value || undefined,
                                   training?.name || "",
                                   training?.fields?.location || "",
                                   training?.fields?.trainingDate || "",
                                   training?.fields?.trainingEndDate || "",
                                   product?.qtyOnHand,
                                   product?.byPassInventory
                               )
                           }
                       >
                           {training?.fields?.buttonText}{isInventoryLoading && <LoadingSpinner {...styles.btnSpinner} />}
                       </Button>: product?.qtyOnHand === 0 ? (
                                <Button
                                    {...styles.featuredRegisterNowButton}
                                    variant="secondary"
                                    onClick={() =>{
                                            openModalHandler(
                                                training?.fields?.registrationType || "", 
                                                training?.fields?.externalLink?.value || undefined,
                                                training?.name || "",
                                                training?.fields?.location || "",
                                                training?.fields?.trainingDate || "",
                                                training?.fields?.trainingEndDate || "",
                                                product?.qtyOnHand,
                                                product?.byPassInventory
                                            )
                                        }
                                    }
                                >
                                    {translate("Join training")}
                                </Button>
                            ) : (
                                <Button
                                    variant="secondary"
                                    {...styles.featuredRegisterNowButton}
                                    disabled={product?.qtyOnHand === 0}
                                    onClick={() =>
                                        openModalHandler(
                                            training?.fields?.registrationType || "", 
                                            training?.fields?.externalLink?.value || undefined,
                                            training?.name || "",
                                            training?.fields?.location || "",
                                            training?.fields?.trainingDate || "",
                                            training?.fields?.trainingEndDate || "",
                                            product?.qtyOnHand,
                                            product?.byPassInventory
                                        )
                                    }
                                >
                                    {training?.fields?.buttonText}{isInventoryLoading && <LoadingSpinner {...styles.btnSpinner} />}
                                </Button>
                            )
                        }
                            </>
                        }
                        <Link
                            href={links[training.nodeId]?.url}
                            target={training?.fields?.openInNewWindow ? "_blank" : ""}
                            {...styles.featuredKnowMoreLink}
                        >
                            Learn More
                        </Link>
                    </StyledWrapper>
                </StyledWrapper>
            </>
        );
    };

    const closeModalHandler = () => {
        setRegistrationModalOpen(false);
        setTrainingRedirectModalOpen(false);
        setSelectedTraining("");
        setSelectedAddress("");
        setSelectedStartDate("");
        setSelectedEndDate("");
        setIsCheckInventory(false);
    };

    const featuredCardsCarousel = (featuredTrainings: any) => {
        const gap = maxCarouselColumns === 1 ? 0 : maxCarouselColumns === 2 ? 10 : 13.33;
        return featuredTrainings.map((training: { id: React.Key | undefined, name: string }) => {
            const product = trainingProductWithId.filter((myTraining: any) => myTraining.name === training.name)[0];
            return (
                <FlexItem
                    key={training?.id}
                    {...styles.featuredItem}
                    style={{
                        width: `calc(100% / ${maxCarouselColumns} - ${gap}px`,
                        minWidth: `calc(100% / ${maxCarouselColumns} - ${gap}px`,
                    }}
                >
                    {featuredCardContent(training, product)}
                </FlexItem>
            )
        });
    };

    const redirectHandler = (from: string) => {
        if(from === "createAccount") {
            if (!createAccountUrl) {
                return;
            }
            history.push(createAccountUrl);
        } else {
            const returnUrl = location.pathname + location.search;
                if (returnUrl === "/") {
                    history.push(`${signInUrl}`);
                } else {
                    history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}`);
                }
        }
    }

    const trainingCheckHandler = (event: any) => {
        event.preventDefault();
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        function isValidEmail(){
            return emailRegex.test(formEmail);
        }
        if(isValidEmail() && formName){

            trainingEnquiry({
                Message: message,
                Email: formEmail,
                Name: formName,
                onSuccess: () => {
                    setIsTrainingCheckModel(false);
                    setMessage("");
                    toaster.addToast({
                        body: translate("Enquiry has been sent successfully!"),
                        messageType: "success"
                    });
                }
            });

        } else {
            if(!formName){
                setNameError("Name is required!");
            }
            if(!formEmail){
                setEmailError("Email is required!");
            }
            if(!isValidEmail() && formEmail){
                setEmailError("Email is not valid!");
            }
            
        }

        
    }
    
    const formNameChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormName(event.target.value)
    };

    const formEmailChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormEmail(event.target.value)
    };
    const messageChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setMessage(event.target.value)
    };

    const fetchInventory = (product: any) => {
        getTrainingProduct({
            data: [...product],
            onSuccess: (result: any) => {
                const trainingWithId = [...result];
                const productIds = trainingWithId.filter((product: any) => product.productId !== "" && !product.byPassInventory).map((product: any) => product.productId)
                loadRealTimeInventory({
                    productIds,
                    onComplete: (data: any) => {
                        const realTimeInventory = data?.apiResult?.realTimeInventoryResults;
                        trainingWithId.forEach((training) => {
                            realTimeInventory.forEach((inventory: any) => {
                                if(inventory.productId === training.productId) {
                                    training["qtyOnHand"] = inventory.qtyOnHand;
                                }
                            });
                        });
                        setTrainingProductWithId(trainingWithId);
                        setIsInventoryLoading(false);
                    },
                    onError(){
                        setTrainingProductWithId(trainingWithId || null);
                        setIsInventoryLoading(false);
                    }
                })
            }
        });
    }

    if (trainings.length === 0) {
        return null;
    }

    const featuredTrainings = trainings.filter(training => training?.fields?.featured);

    return (
        <StyledWrapper {...styles.container}>
            {featuredTrainings.length > 0 && (
                <StyledWrapper {...styles.featuredContainer}>
                    <StyledWrapper {...styles.featuredTitleSection}>
                        <Zone contentId={id} zoneName="SectionTitle1" />
                    </StyledWrapper>

                    {featuredTrainings.length > 3 && (
                        <EmblaCarousel
                            options={{
                                align: "start",
                                slidesToScroll: maxCarouselColumns,
                                containScroll: "trimSnaps",
                            }}
                        >
                            {featuredCardsCarousel(featuredTrainings)}
                        </EmblaCarousel>
                    )}
                    {featuredTrainings.length <= 3 && (
                        <StyledWrapper {...styles.featuredCardsContainer}>
                            {featuredTrainings.map(training => {
                                const product = trainingProductWithId.filter((myTraining: any) => myTraining.name === training.name)[0];
                                return <StyledWrapper key={training.id}>{featuredCardContent(training, product)}</StyledWrapper>;
                            })}
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            )}
            <StyledWrapper className="training-wrapper" {...styles.trainingNotificationWrapper}>
                <StyledWrapper className="training-overlay-wrapper" {...styles.trainingNotificationOverlay}>
                    <StyledWrapper className="training-center-wrapper" {...styles.trainingNotificationContentWrapper}>
                        <StyledWrapper>
                            <Typography {...styles.heading}>{translate("Is there a training your are interested in, but do not see? Let us know!")}</Typography>
                        </StyledWrapper>
                        <Button {...styles.trainingNotificationButton} onClick={() => setIsTrainingCheckModel(true)}>
                            {translate("Check Training")}
                        </Button>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
            <GridContainer {...styles.trainingsGridContainer}>
                <GridItem {...styles.trainingTitleSection}>
                    <Zone contentId={id} zoneName="SectionTitle2" />
                </GridItem>
                <GridItem {...styles.filtersGridItem}>
                    <StyledWrapper {...styles.filterHeadingWrapper}>
                        <Typography {...styles.filterSectionHeading}>Filter</Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.filterSectionsWrapper}>
                        {typeFilters.length > 0 && (
                            <TrainingFiltersAccordionSection
                                title="By Training Type"
                                facets={typeFilters}
                                onChangeFacet={handleFacetChange}
                                selectedFilterNamesArr={selectedFilterNamesArr}
                            />
                        )}
                        {locationFilters.length > 0 && (
                            <TrainingFiltersAccordionSection
                                title="By Location"
                                facets={locationFilters}
                                onChangeFacet={handleFacetChange}
                                selectedFilterNamesArr={selectedFilterNamesArr}
                            />
                        )}
                        <TrainingFiltersAccordionSection
                            title="By Price"
                            facets={priceFilters}
                            onChangeFacet={handleFacetChange}
                            selectedFilterNamesArr={selectedFilterNamesArr}
                            isPrice={true}
                        />

                        {peuFilters.length > 0 && (
                            <TrainingFiltersAccordionSection
                                title="By PEUs"
                                facets={peuFilters}
                                onChangeFacet={handleFacetChange}
                                selectedFilterNamesArr={selectedFilterNamesArr}
                            />
                        )}
                        {restrictionFilters.length > 0 && (
                            <TrainingFiltersAccordionSection
                                title="By Restrictions"
                                facets={restrictionFilters}
                                onChangeFacet={handleFacetChange}
                                selectedFilterNamesArr={selectedFilterNamesArr}
                            />
                        )}
                    </StyledWrapper>
                </GridItem>
                {filteredTrainings.length === 0 && (
                    <GridItem {...styles.noResultGridItem}>
                        <Typography variant="h2">No Training Found</Typography>
                    </GridItem>
                )}
                <GridItem {...styles.cardsGridItem}>
                    {filteredTrainings.length > 0 &&
                        filteredTrainings.map((training: any, i: any) => {
                            const product = trainingProductWithId.filter((myTraining: any) => myTraining.name === training.name)[0];
                            let seatAvailableMessage = "";
                            if(product?.byPassInventory){
                                seatAvailableMessage = "Seat Availability - Open";
                            }else if(product?.qtyOnHand > 5) {
                                seatAvailableMessage = "Seat Availability - Open";
                            } else if(product?.qtyOnHand <= 5 && product?.qtyOnHand >= 1) {
                                seatAvailableMessage =`Seat Availability - Only ${product?.qtyOnHand} Seats Left!`;
                            } else if(product?.qtyOnHand === 0) {
                                seatAvailableMessage = "Seat Availability - Class Full"
                            }
                            return (
                                <StyledWrapper {...styles.card} key={training.id}>
                                    <Clickable
                                        href={links[training.nodeId]?.url}
                                        target={training?.fields?.openInNewWindow ? "_blank" : ""}
                                        css={css`
                                            background: #fff;
                                        `}
                                    >
                                        <LazyImage
                                            {...styles.trainingCardImg}
                                            src={training?.fields?.trainingImage}
                                        ></LazyImage>
                                    </Clickable>
                                    <StyledWrapper {...styles.trainingCardContent}>
                                        <StyledWrapper>
                                            <Typography {...styles.trainingType} className="testing">
                                                {training?.fields?.trainingType}
                                            </Typography>
                                            <Link
                                                href={links[training.nodeId]?.url}
                                                target={training?.fields?.openInNewWindow ? "_blank" : ""}
                                                {...styles.learnMoreLink}
                                            >
                                                <Typography {...styles.title}>{training?.fields?.title}</Typography>
                                            </Link>
                                            

                                            {training?.fields?.location && (
                                                <StyledWrapper {...styles.detailsWrapper}>
                                                    <Icon src={locationIcon} {...styles.detailIcon}></Icon>
                                                    <Typography {...styles.location}>
                                                        {training?.fields?.location}
                                                    </Typography>
                                                </StyledWrapper>
                                            )}

                                            {training?.fields?.trainingDate && (
                                                <StyledWrapper {...styles.detailsWrapper}>
                                                    <Icon src={calendarIcon} {...styles.detailIcon}></Icon>
                                                    <StyledWrapper {...styles.datesWrapper}>
                                                        <Typography {...styles.date}>
                                                            {getLocalizedDateTime({
                                                                dateTime: new Date(training?.fields?.trainingDate),
                                                            })}
                                                            {" | "}
                                                            {getTime(training?.fields?.trainingDate)}
                                                            {training?.fields?.trainingEndDate && <>&nbsp;-&nbsp;</>}
                                                        </Typography>
                                                        {training?.fields?.trainingEndDate && (
                                                            <Typography {...styles.endDate}>
                                                                {getLocalizedDateTime({
                                                                    dateTime: new Date(
                                                                        training?.fields?.trainingEndDate,
                                                                    ),
                                                                })}
                                                                {" | "}
                                                                {getTime(training?.fields?.trainingEndDate)}
                                                            </Typography>
                                                        )}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            )}

                                            {training?.fields?.price && (
                                                <StyledWrapper {...styles.detailsWrapper}>
                                                    <Icon src={tagIcon} {...styles.detailIcon}></Icon>
                                                    <Typography
                                                        {...styles.price}
                                                    >{`$ ${training?.fields?.price}`}</Typography>
                                                </StyledWrapper>
                                            )}

                                            {training?.fields?.peu && (
                                                <StyledWrapper {...styles.detailsWrapper}>
                                                    <Icon src={peuIcon} {...styles.detailIcon}></Icon>
                                                    <Typography {...styles.price}>{training?.fields?.peu}</Typography>
                                                </StyledWrapper>
                                            )}

                                            {training?.fields?.restriction && (
                                                <StyledWrapper {...styles.detailsWrapper}>
                                                    <Icon src={restrictionIcon} {...styles.detailIcon}></Icon>
                                                    <Typography {...styles.price}>
                                                        {training?.fields?.restriction}
                                                    </Typography>
                                                </StyledWrapper>
                                            )}
                                            {isInventoryLoading ? "Loading..." :
                                            product?.byPassInventory ? <StyledWrapper {...styles.detailsWrapper}>
                                            <Typography {...styles.qty}>
                                                {seatAvailableMessage}
                                            </Typography>
                                        </StyledWrapper> : product?.qtyOnHand !== undefined && (
                                                <StyledWrapper {...styles.detailsWrapper}>
                                                    <Typography {...styles.qty}>
                                                        {seatAvailableMessage}
                                                    </Typography>
                                                </StyledWrapper>
                                            )}
                                        </StyledWrapper>

                                        <StyledWrapper {...styles.buttonWrapper}>
                                            {training?.fields?.registrationType !== "regNotRequired" &&
                                            <>
                                            {
                                                product?.byPassInventory ? (
                                                    <Button
                                                        {...styles.registerNowButton}
                                                        variant="secondary"
                                                        disabled={product?.qtyOnHand === 0}
                                                        onClick={() =>{
                                                                openModalHandler(
                                                                    training?.fields?.registrationType || "", 
                                                                    training?.fields?.externalLink?.value || undefined,
                                                                    training?.name || "",
                                                                    training?.fields?.location || "",
                                                                    training?.fields?.trainingDate || "",
                                                                    training?.fields?.trainingEndDate || "",
                                                                    product?.qtyOnHand,
                                                                    product?.byPassInventory
                                                                )
                                                            }
                                                        }
                                                    >
                                                        {training?.fields?.buttonText}{isInventoryLoading && <LoadingSpinner {...styles.btnSpinner} />}
                                                    </Button>
                                                ): product?.qtyOnHand === 0 ? (
                                                    <Button
                                                        {...styles.registerNowButton}
                                                        variant="secondary"
                                                        onClick={() =>{
                                                                openModalHandler(
                                                                    training?.fields?.registrationType || "", 
                                                                    training?.fields?.externalLink?.value || undefined,
                                                                    training?.name || "",
                                                                    training?.fields?.location || "",
                                                                    training?.fields?.trainingDate || "",
                                                                    training?.fields?.trainingEndDate || "",
                                                                    product?.qtyOnHand,
                                                                    product?.byPassInventory
                                                                )
                                                            }
                                                        }
                                                    >
                                                        {translate("Join training")}
                                                    </Button>
                                                ): (
                                                    <Button
                                                        {...styles.registerNowButton}
                                                        variant="secondary"
                                                        disabled={product?.qtyOnHand === 0}
                                                        onClick={() =>{
                                                                openModalHandler(
                                                                    training?.fields?.registrationType || "", 
                                                                    training?.fields?.externalLink?.value || undefined,
                                                                    training?.name || "",
                                                                    training?.fields?.location || "",
                                                                    training?.fields?.trainingDate || "",
                                                                    training?.fields?.trainingEndDate || "",
                                                                    product?.qtyOnHand,
                                                                    product?.byPassInventory
                                                                )
                                                            }
                                                        }
                                                    >
                                                        {training?.fields?.buttonText}{isInventoryLoading && <LoadingSpinner {...styles.btnSpinner} />}
                                                    </Button>
                                                )
                                            }
                                                </>
                                            }
                                            <Link
                                                href={links[training.nodeId]?.url}
                                                target={training?.fields?.openInNewWindow ? "_blank" : ""}
                                                {...styles.learnMoreLink}
                                            >
                                                Learn More
                                            </Link>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                </StyledWrapper>
                            );
                        })}
                </GridItem>
            </GridContainer>
            <TrainingRegistrationPopup
                selectedTraining={selectedTraining}
                selectedAddress={selectedAddress}
                selectedStartDate={selectedStartDate}
                selectedEndDate={selectedEndDate}
                isOpen={registrationModalOpen}
                closeModalHandler={closeModalHandler} 
                showAddToCartConfirmationDialog={false}
                hasEnoughInventory={undefined} 
                isAddToCartButtonDisabled={undefined}
                trainingQty={selectTrainingQty}
                cartPageUrl={cartPageUrl}
                isCheckInventory={isCheckInventory}
            ></TrainingRegistrationPopup>
            <Modal
                headline={translate("Create Account or Sign In")}
                {...styles.trainingRedirectionModal}
                isOpen={trainingRedirectModalOpen}
                handleClose={() => setTrainingRedirectModalOpen(false)}>
                <TrainingRedirectionPopup
                    redirectHandler={redirectHandler}
                />
            </Modal>
            <Modal
                {...styles.modal}
                headline={translate("Training Enquiry")}
                isOpen={isTrainingCheckModel}
                handleClose={() => setIsTrainingCheckModel(false)}
            >
                <form onSubmit={trainingCheckHandler} noValidate>
                    {TrainingEnquiry.isTrainingEnquiry ? (
                        <StyledWrapper {...styles.centeringWrapper}>
                            <LoadingSpinner {...styles.spinner} />
                        </StyledWrapper>
                    ) : (
                        <GridContainer {...styles.containerEnquiry} data-test-selector="requestConvertQuote_modal">
                            <GridItem {...styles.messageGridItem}>
                               <TextField onFocus={()=>setNameError("")} required={true} {...styles.textInput}  label={translate("Name")}  onChange={(e)=>formNameChangeHandler(e)} value={formName} />
                                {nameError &&
                                   <Typography {...styles.errorText}>{siteMessage(nameError)}</Typography>
                                }
                            </GridItem>
                            <GridItem {...styles.messageGridItem}>
                                <TextField onFocus={()=>setEmailError("")} required={true} {...styles.textInput} label={translate("Email")}  onChange={(e)=>formEmailChangeHandler(e)} value={formEmail} />
                                {emailError &&
                                    <Typography {...styles.errorText}>{siteMessage(emailError)}</Typography>
                                }
                            </GridItem>
                            <GridItem {...styles.messageGridItem}>
                                <TextArea
                                    label={translate("Message")}
                                    value={message}
                                    onChange={messageChangeHandler}
                                    data-test-selector="requestConvertQuote_message"
                                    {...styles.messageTextArea}
                                />
                            </GridItem>
                        </GridContainer>
                    )}
                    <StyledWrapper {...styles.buttonsWrapper}>
                        <Button
                            {...styles.cancelButton}
                            onClick={() => setIsTrainingCheckModel(false)}
                            data-test-selector="training_enquiry_cancel"
                        >
                            {translate("Cancel")}
                        </Button>
                        <Button
                            {...styles.sendButton}
                            data-test-selector="training_enquiry_submit"
                        >
                            {translate("Send")}
                        </Button>
                    </StyledWrapper>
                </form>
            </Modal>
            
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withIsInShell(withToaster(withHistory(withTheme(crescentPartsTrainingsListView)))));
